<template>
  <div class="header">
        <a href="https://www.nonda.co">
            <img class="logo" src="https://cdn.shopifycdn.net/s/files/1/0703/1149/files/logo_2.png?v=1618222123" alt="nonda">
        </a>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  
})
</script>
<style style="scss" scoped>
.header{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    background: #000;
}
.logo{
    width: 120px;
    -webkit-filter: invert(1);
    filter: invert(1);
}
</style>
